import { createPortal } from 'react-dom';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
interface IPropsType {
    goBack: () => void;
    goNext: () => void;
    disabledNextBtn?: boolean;
    nextText?: string;
}
export default function SuspendedButton({ goBack, goNext, disabledNextBtn, nextText }: IPropsType) {
    const { isMobile, useLang } = useGlobal();
    const { t } = useLang('calculatorssolarpanels');
    if (typeof window === 'undefined') return null;
    const targetDomNode = document.body;
    const jsxEle = (
        <div className={`${css.action_wrapper} font-family-semibold`}>
            <button className="back btn" onClick={goBack}>
                {t('cacl_step2_back_btn')}
            </button>
            <button className={`next btn ${disabledNextBtn ? 'disabled' : ''}`} onClick={goNext}>
                {nextText || t('cacl_step2_next_btn')}
            </button>
        </div>
    );
    return isMobile ? createPortal(jsxEle, targetDomNode) : jsxEle;
}
